import styled from "styled-components";
import { heightHelper } from "./helper";
import Label from "../Label";
import { spacingHelper, typographyHelper } from "../../utils";
export var TextInputWrapper = styled.div.withConfig({
  displayName: "styles__TextInputWrapper",
  componentId: "sc-15pd6ix-0"
})(["text-align:left;position:relative;"]);
export var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-15pd6ix-1"
})(["align-items:center;display:flex;height:", ";", ";", ""], heightHelper, _ref => {
  var {
    $sizeVariant,
    theme,
    $addMargin
  } = _ref;
  return $addMargin && "margin-right: \n    " + ($sizeVariant === "small" ? theme.spacing.small : theme.spacing.medium);
}, _ref2 => {
  var {
    $disabled,
    theme
  } = _ref2;
  return $disabled && "color: " + theme.palette.textDisabled + ";";
});
export var StyledLabel = styled(Label).withConfig({
  displayName: "styles__StyledLabel",
  componentId: "sc-15pd6ix-2"
})(["margin-bottom:", ";"], spacingHelper("twoExtraSmall"));
export var DollarWrapper = styled.span.withConfig({
  displayName: "styles__DollarWrapper",
  componentId: "sc-15pd6ix-3"
})(["color:", ";min-width:", ";display:flex;justify-content:center;", ""], _ref3 => {
  var {
    $doesValueExist,
    theme
  } = _ref3;
  return $doesValueExist ? theme.palette.textPrimary : theme.palette.textSecondary;
}, spacingHelper("medium"), _ref4 => {
  var {
    $sizeVariant
  } = _ref4;
  return typographyHelper($sizeVariant === "small" ? "body02" : "body01");
});